var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect, useCallback } from 'react';
export function usePageVisibility() {
    var _a = __read(useState(true), 2), isVisible = _a[0], setIsVisible = _a[1];
    var onVisibilityChange = useCallback(function () { return setIsVisible(getIsDocumentVisible()); }, [setIsVisible]);
    useEffect(function () {
        var browserVisibilityProp = getBrowserVisibilityProp();
        window.addEventListener(browserVisibilityProp, onVisibilityChange, false);
        return function () {
            window.removeEventListener(browserVisibilityProp, onVisibilityChange);
        };
    }, [onVisibilityChange]);
    return isVisible;
}
function getBrowserVisibilityProp() {
    if (typeof document['msHidden'] !== 'undefined') {
        return 'msvisibilitychange';
    }
    else if (typeof document['webkitHidden'] !== 'undefined') {
        return 'webkitvisibilitychange';
    }
    return 'visibilitychange';
}
function getBrowserDocumentHiddenProp() {
    if (typeof document['msHidden'] !== 'undefined') {
        return 'msHidden';
    }
    else if (typeof document['webkitHidden'] !== 'undefined') {
        return 'webkitHidden';
    }
    return 'hidden';
}
function getIsDocumentVisible() {
    return !document[getBrowserDocumentHiddenProp()];
}
//# sourceMappingURL=use-page-visibility.js.map